/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overall_RatingInputs */

const en_overall_rating = /** @type {(inputs: Overall_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall rating`)
};

const de_overall_rating = /** @type {(inputs: Overall_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtbewertung`)
};

/**
* | output |
* | --- |
* | "Overall rating" |
*
* @param {Overall_RatingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const overall_rating = /** @type {((inputs?: Overall_RatingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overall_RatingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_overall_rating(inputs)
	return en_overall_rating(inputs)
});